import { sendPost } from 'api/axios';
import images from 'assets/images-base';
import { acceptFileMicrosoft } from 'common/constant';
import { formatUrl } from 'helper';
import * as React from 'react';
import { PluginProps } from 'react-markdown-editor-lite';
import { MicrosoftUploadStyle, UploadIcon } from './microsoftUploadStyle';
import { REGEX_ACCEPT_FILE_UPLOAD_EXCEPT_IMAGE, REGEX_FILE_PPTX } from 'helper/regex';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { storeSetIsLoadingCreatePost } from 'store/create-post-reducer';

const uploadFile = async (file: any) => {
  const data = new FormData();
  data.append('file', file);
  data.append('type', '1');
  const res = await sendPost(`/upload-file`, data);
  return formatUrl(res?.data?.url_file);
};

const Translate: React.FC<{ text: string }> = ({ text }) => {
  const { t } = useTranslation();
  return <>{t(text)}</>;
};

const MicrosoftUpload = (props: PluginProps) => {
  const dispatch = useDispatch();

  const onUploadFile = async (options: any) => {
    const file = options?.file;
    if (file.size / 1024 / 1024 >= 20) {
      message.error(<Translate text="createPost.uploadMax" />);
      return;
    }

    if (!REGEX_ACCEPT_FILE_UPLOAD_EXCEPT_IMAGE.test(file.type)) {
      message.error(<Translate text="createPost.errorUploadFile" />);
      return;
    }

    dispatch(storeSetIsLoadingCreatePost(true));

    uploadFile(file)
      .then((url) => {
        if (REGEX_FILE_PPTX.test(file.type)) {
          props.editor.insertText(`<microsoft src=${url}></microsoft>`, true);
        } else {
          props.editor.insertText(' ' + url);
        }
        dispatch(storeSetIsLoadingCreatePost(false));
      })
      .catch(() => {
        dispatch(storeSetIsLoadingCreatePost(false));
        message.error(<Translate text="editor.errorSystem" />);
      });
  };

  return (
    <MicrosoftUploadStyle accept={acceptFileMicrosoft} customRequest={onUploadFile} fileList={[]}>
      <UploadIcon src={images.createPost.MicrosoftUpload} />
    </MicrosoftUploadStyle>
  );
};

MicrosoftUpload.defaultConfig = {
  start: 0,
};
MicrosoftUpload.align = 'left';
MicrosoftUpload.pluginName = 'microsoft-upload';

export default MicrosoftUpload;
